export function centeredScrollOffset(
  scrollSize: number,
  clientSize: number
): number {
  const overflow = scrollSize - clientSize;
  return overflow > 0 ? overflow / 2 : 0;
}
